var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowPolyGridHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422 309L498 247L432 217Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 309L532 279L498 247Z",
    fill: "#ffffff",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 217L324 232L422 309Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 309L531 371L532 279Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 232L313 273L422 309Z",
    fill: "#d5a67b",
    stroke: "#d5a67b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 309L446 436L531 371Z",
    fill: "#e3c0a1",
    stroke: "#e3c0a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 305L591 238L532 279Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 279L591 238L498 247Z",
    fill: "#fcf6f1",
    stroke: "#fcf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498 247L502 120L432 217Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 238L502 120L498 247Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 217L374 49L324 232Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 371L609 305L532 279Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 392L446 436L422 309Z",
    fill: "#f0dbc8",
    stroke: "#f0dbc8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 273L304 392L422 309Z",
    fill: "#dfb794",
    stroke: "#dfb794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 494L473 470L446 436Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 436L473 470L531 371Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 351L649 338L609 305Z",
    fill: "#ffffff",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 143L250 201L324 232Z",
    fill: "#ffffff",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 232L250 201L313 273Z",
    fill: "#e3c0a1",
    stroke: "#e3c0a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 273L181 282L304 392Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 351L609 305L531 371Z",
    fill: "#f0dbc8",
    stroke: "#f0dbc8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 305L717 196L591 238Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 395L649 351L531 371Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 120L374 49L432 217Z",
    fill: "#ecd2bb",
    stroke: "#ecd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 49L255 143L324 232Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 392L396 494L446 436Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 196L612 94L591 238Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 238L612 94L502 120Z",
    fill: "#e3c0a1",
    stroke: "#e3c0a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 120L448 0L374 49Z",
    fill: "#ecd2bb",
    stroke: "#ecd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 351L667 395L649 338Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 338L717 196L609 305Z",
    fill: "#d5a67b",
    stroke: "#d5a67b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 496L667 395L531 371Z",
    fill: "#dfb794",
    stroke: "#dfb794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 0L448 0L502 120Z",
    fill: "#e3c0a1",
    stroke: "#e3c0a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 149L181 282L250 201Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 201L181 282L313 273Z",
    fill: "#ecd2bb",
    stroke: "#ecd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 392L280 528L396 494Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 0L516 0L502 120Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789 193L717 196L815 324Z",
    fill: "#ecd2bb",
    stroke: "#ecd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612 94L557 0L502 120Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 470L604 496L531 371Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 600L604 496L473 470Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 0L191 149L255 143Z",
    fill: "#d5a67b",
    stroke: "#d5a67b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 143L191 149L250 201Z",
    fill: "#ffffff",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 0L255 143L374 49Z",
    fill: "#d5a67b",
    stroke: "#d5a67b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 0L349 0L374 49Z",
    fill: "#d5a67b",
    stroke: "#d5a67b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669 0L557 0L612 94Z",
    fill: "#ffffff",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 196L726 143L612 94Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 507L280 528L304 392Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 494L439 600L473 470Z",
    fill: "#d5a67b",
    stroke: "#d5a67b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 412L237 507L304 392Z",
    fill: "#f0dbc8",
    stroke: "#f0dbc8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 325L160 412L181 282Z",
    fill: "#fcf6f1",
    stroke: "#fcf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 282L160 412L304 392Z",
    fill: "#ecd2bb",
    stroke: "#ecd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 600L439 600L396 494Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726 143L669 0L612 94Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 324L717 196L649 338Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 196L789 193L726 143Z",
    fill: "#fcf6f1",
    stroke: "#fcf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726 143L779 64L669 0Z",
    fill: "#ffffff",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439 600L542 600L473 470Z",
    fill: "#ffffff",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 496L743 487L667 395Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 70L110 187L191 149Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 149L110 187L181 282Z",
    fill: "#e3c0a1",
    stroke: "#e3c0a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 600L349 600L280 528Z",
    fill: "#dfb794",
    stroke: "#dfb794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 528L349 600L396 494Z",
    fill: "#e3c0a1",
    stroke: "#e3c0a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 600L562 600L604 496Z",
    fill: "#ffffff",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 395L815 324L649 338Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 0L209 0L255 143Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725 600L743 487L604 496Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 386L815 324L667 395Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 187L83 325L181 282Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 600L190 600L237 507Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 0L779 64L900 0Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789 193L779 64L726 143Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 487L818 386L667 395Z",
    fill: "#dfb794",
    stroke: "#dfb794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 331L54 406L83 325Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 325L54 406L160 412Z",
    fill: "#fcf6f1",
    stroke: "#fcf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 507L190 600L280 528Z",
    fill: "#dfb794",
    stroke: "#dfb794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 522L237 507L160 412Z",
    fill: "#e3c0a1",
    stroke: "#e3c0a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 94L779 64L789 193Z",
    fill: "#d5a67b",
    stroke: "#d5a67b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 64L780 0L669 0Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 600L725 600L604 496Z",
    fill: "#fcf6f1",
    stroke: "#fcf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 487L838 494L818 386Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 0L59 70L191 149Z",
    fill: "#f0dbc8",
    stroke: "#f0dbc8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 187L0 219L83 325Z",
    fill: "#dfb794",
    stroke: "#dfb794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 419L900 258L815 324Z",
    fill: "#d5a67b",
    stroke: "#d5a67b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 324L900 258L789 193Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 419L815 324L818 386Z",
    fill: "#f0dbc8",
    stroke: "#f0dbc8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793 600L838 494L743 487Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 70L0 219L110 187Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 219L0 331L83 325Z",
    fill: "#dfb794",
    stroke: "#dfb794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 406L61 522L160 412Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 258L900 196L789 193Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 445L61 522L54 406Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 522L121 600L237 507Z",
    fill: "#f4e4d6",
    stroke: "#f4e4d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838 494L900 419L818 386Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725 600L793 600L743 487Z",
    fill: "#ecd2bb",
    stroke: "#ecd2bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838 494L900 487L900 419Z",
    fill: "#e3c0a1",
    stroke: "#e3c0a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 70L0 51L0 219Z",
    fill: "#e8c9ae",
    stroke: "#e8c9ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 0L50 0L59 70Z",
    fill: "#f0dbc8",
    stroke: "#f0dbc8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 196L900 94L789 193Z",
    fill: "#d5a67b",
    stroke: "#d5a67b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 331L0 445L54 406Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 522L0 600L121 600Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0L0 51L59 70Z",
    fill: "#daaf88",
    stroke: "#daaf88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 600L900 487L838 494Z",
    fill: "#f8ede3",
    stroke: "#f8ede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 445L0 493L61 522Z",
    fill: "#fcf6f1",
    stroke: "#fcf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0L0 0L0 51Z",
    fill: "#fcf6f1",
    stroke: "#fcf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 94L900 0L779 64Z",
    fill: "#ffffff",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 493L0 600L61 522Z",
    fill: "#dfb794",
    stroke: "#dfb794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793 600L900 600L838 494Z",
    fill: "#ecd2bb",
    stroke: "#ecd2bb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPolyGridHaikei);
export default __webpack_public_path__ + "static/media/low-poly-grid-haikei.503d7b3aed9ea214d40eeba36a9346fe.svg";
export { ForwardRef as ReactComponent };